<template>
  <div :class="{'hide-after-action': !item.allConditionsMet || item.hideAfterAction}">
    <Items
      :items="item.items"
      :errors="errors"
      :response-sets="responseSets"
      :show-errors="showErrors"
    />
  </div>
</template>

<script>
  import Items from './Items';

  export default {
    components: { Items },
    props: {
      item: {
        type: Object,
        required: true,
      },
      errors: {
        type: Object,
        required: true,
      },
      showErrors: {
        type: Boolean,
        required: true,
      },
      responseSets: {
        type: Array,
        required: true,
      },
    },
    computed: {},

    methods: {},
  };
</script>
